// AboutUs.js
import React from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import './Help.css';

const AboutUs = () => {
  return (
    <div className="App">
      <Header />
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }} className='help-content'>
        <h1>Terms of Use & Cookie Policy</h1>
        <div className='terms'>
          <h2>Terms of Use</h2>
          <h3>Introduction</h3>
          <p>Welcome to Domogogo. These Terms of Use ("Terms") govern your access to and use of our Website and services. By accessing or using our Website, you agree to these Terms.</p><br/>
          <h3>1. Use of the Website</h3>
          <p>1.1 You must be at least 18 years old to use our Website.<br/>1.2 You agree to provide accurate and up-to-date information when creating an account.</p><br/>
          <h3>2. User Responsibilities</h3>
          <p>2.1 You agree not to use the Website for any unlawful purposes, including but not limited to:
            <ul style={{marginLeft:"20px",}}>
              <li>Submitting false or misleading information.</li>
              <li>Engaging in unauthorized data scraping.</li>
            </ul>
          2.2 You are responsible for maintaining the confidentiality of your account login credentials.</p><br/>
          <h3>3. Privacy and Data Usage</h3>
          <p>Your use of the Website is also governed by our Privacy Policy, which explains how we collect, use, and protect your data.</p><br/>
          <h3>4. Intellectual Property</h3>
          <p>All content on the Website, including text, images, and code, is the property of Domogogo or its licensors and is protected by copyright and other intellectual property laws.</p><br/>
          <h3>5. Limitation of Liability</h3>
          <p>We are not liable for:
            <ul style={{marginLeft:"20px",}}>
              <li>Any loss or damage resulting from your use of the Website.</li>
              <li>Errors, interruptions, or unavailability of the Website.</li>
            </ul><br/>
          </p>
          <h3>6. Third-Party Services</h3>
          <p>Our Website integrates third-party services like Firebase and Stripe. We are not responsible for the practices or content of these services.</p><br/>
          <h3>7. Termination</h3>
          <p>We reserve the right to suspend or terminate your account for violating these Terms or engaging in prohibited activities.</p><br/>
          <h3>8. Dispute Resolution</h3>
          <p>Any disputes arising under these Terms will be resolved through arbitration in accordance with the laws of the United Kingdom.</p><br/>
          <h3>9. Modifications to the Terms</h3>
          <p>We may update these Terms at our discretion. Continued use of the Website after updates constitutes acceptance of the new Terms.</p><br/>
          <h3>10. Subscription Services</h3>
          <p><strong>Subscription Plans:</strong> Domogogo offers a Basic plan and a Premium plan. Basic plan users can add up to two properties to their search. Premium plan users can add up to 100 properties, with additional features potentially being introduced to the Premium plan in the future.</p>
          <p><strong>Payment and Billing:</strong> All payments are securely processed through Stripe. Subscriptions are billed on a monthly basis at the rate displayed at the time of subscription. Subscriptions automatically renew on the same day each month as the initial subscription start date, unless canceled by the user.</p>
          <p><strong>Refund Policy:</strong> Subscription fees are non-refundable. However, we encourage users experiencing issues to contact us, as we are committed to resolving any concerns promptly.</p>
          <p><strong>Subscription Management:</strong> Users can manage their subscription, including cancellation, through the "My Account" page. Cancellation requests are handled via Stripe. Upon cancellation, users retain access to Premium features until the end of their current billing cycle, after which their account will revert to the Basic plan.</p>
          <p><strong>Changes to Subscription Terms:</strong> We reserve the right to update subscription pricing or features. In such cases, users will be provided with at least 30 days' notice, including at least one full billing cycle prior to the changes taking effect.</p><br/>

          <h3>11. Contact Us</h3>
          <p>If you have any questions about these Terms, please contact us at hello@domogogo.com</p><br/>

          <h2>Cookie Policy</h2>
          <p>This Cookie Policy explains how Domogogo ("we," "us," or "our") uses cookies and similar technologies to recognize you when you visit our website at https://www.domogogo.com ("Website"). It explains what these technologies are and why we use them, as well as your rights to control their use.</p><br/>
          <h3>What Are Cookies?</h3>
          <p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.</p><br/>
          <h3>Types of Cookies We Use</h3>
          <ul style={{marginLeft:"20px",}}>
            <li><strong>Essential Cookies</strong>: Necessary for the functionality of our Website, such as enabling you to log in and access secure areas as well as displaying the properties you have previously selected</li>
            <li><strong>Performance and Analytics Cookies</strong>: Help us understand how our Website is being used, such as which pages are most popular.</li>
          </ul><br/>
          <h3>Third-Party Cookies</h3>
          <p>Some cookies are placed by third parties, including:</p>
          <ul style={{marginLeft:"20px",}}>
            <li><strong>Firebase</strong>: Used for authentication and database management.</li>
            <li><strong>Stripe</strong>: Utilized for payment processing.</li>
          </ul><br/>
          <h3>Your Choices</h3>
          <p>You can manage your cookie preferences through your browser settings. Note that disabling some cookies may affect the functionality of our Website.</p><br/>
          <h3>Updates to This Policy</h3>
          <p>We may update this Cookie Policy from time to time to reflect changes in our practices. The updated policy will be available on this page.</p><br/>
          <h3>Contact Us</h3>
          <p>For questions about this Cookie Policy, please contact us at hello@domogogo.com</p><br/>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
